/* @flow */
import React from 'react'
import { Translate } from 'react-redux-i18n'
import Rating from 'react-rating'
import Chip from '@material-ui/core/Chip'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import faStar from '@fortawesome/fontawesome-free-regular/faStar'
import faFullStar from '@fortawesome/fontawesome-free-solid/faStar'
import _ from 'lodash'

import './style.css'
import Button from '../Button';
import { flexbox } from '@material-ui/system';

type PreviewP = {
  data: {},
}
class Preview extends React.Component<PreviewP> {
  constructor(props) {
    super(props)
    this.state = {
      isExpanded: false
    }
  }

  toggleExpand = (e) => {
    this.setState({ isExpanded: !this.state.isExpanded })
    e.preventDefault()
    e.stopPropagation()
  }

  render() {
    const {
      imageOnLeft,
      width,
      funcIcon,
      onFuncIconClick,
      locale,
      className,
      data,
      subtitle,
      options,
      showIntro,
      footer,
      expandable,
      expandContent,
      onClick,
      onHeaderClick,
    } = this.props
    const { isExpanded } = this.state
    let name = ''
    if (data) {
      if (_.isObject(data.name)) {
        name = data.name[locale]
      } else {
        name = data.name
      }
    }
    return data ? (
      <div className={'preview-container ' + className + (onClick ? ' clickable' : '') + (isExpanded ? ' expanded' : '') + (imageOnLeft ? ' preview-row' : '')} style={{ width: width ? width+'px' : 'auto' }} onClick={onClick}>
        <div className="image-wrapper">
          <img src={data.thumb || ( data.photos && (data.photos[0].url || data.photos[0]) )} alt={data.id} />
          { data.videoId ?
            <div className="type-icon">
              <i className="icon icon-preview-360" />
            </div> : null
          }
          { funcIcon && (
            <a className="func-icon clickable"
              onClick={onFuncIconClick}>
              {funcIcon}
            </a>)
          }
        </div>
        <div className="content">
          <div className={"header"+(imageOnLeft ? ' header-row' : '')}>
            <div className='title'>{name || ''}</div>
            <Chip label={subtitle}
              onClick={onHeaderClick}
              className="subtitle"
            />
          </div>
          {
            options.map( (option, idx) => {
              if (option.isRating) {
                if (option.isRatingWithComments && !data.comments) {
                  return null
                }
                return (
                  <div key={data.id + '-' + idx} className="option">
                    {option.title ? <Translate className="label" value={option.title} /> : null}
                    <span className="value">
                      <Rating
                        readonly={true}
                        emptySymbol={option.emptySymbol ? option.emptySymbol : <FontAwesomeIcon size="lg" icon={faStar} />}
                        fullSymbol={option.fullSymbol ? option.fullSymbol : <FontAwesomeIcon size="lg" icon={faFullStar} />}
                        initialRating={parseInt(option.value, 10)} />
                      { option.isRatingWithComments &&
                        <span>({_.values(data.comments).length})</span>
                      }
                    </span>
                  </div>
                )
              }
              return (
                <div key={data.id + '-' + option.title} className="option">
                  { option.title && <Translate className="label" value={option.title} /> }
                  <span className="value">{option.value}</span>
                </div>
              )
            } )
          }
          { showIntro ? <div>{data.intro ? data.intro[locale] || data.intro.cht : data.intro}</div> : null }
          <div className="bottom-bar">
            { footer && footer.map( (item) => (
              !item.hideWhen && (item.isButton ?
                <Button key={data.id + '-' + item.title}
                  type={item.type || 'action'}
                  text={item.title}
                  onClick={item.isToggleExpand ? this.toggleExpand : item.onClick}
                /> :
                item.isRating ?
                  <div key={data.id + '-' + item.title} className="option">
                    {item.title ? <Translate className="label" value={item.title} /> : null}
                    <span className="value">
                      <Rating
                        readonly={true}
                        fractions={2}
                        emptySymbol={item.emptySymbol ? item.emptySymbol : <FontAwesomeIcon size="lg" icon={faStar} />}
                        fullSymbol={item.fullSymbol ? item.fullSymbol : <FontAwesomeIcon size="lg" icon={faFullStar} />}
                        initialRating={parseInt(item.value, 10)} />
                    </span>
                  </div> :
                  <div key={data.id + '-' + item.title} className="option">
                    <Translate className="label" value={item.title} />
                    { item.value ? <span className="value">{item.value}</span> : null }
                  </div>)
              ) )
            }
          </div>
          {
            (expandable && isExpanded) ?
            <div className="expand-content">
              { expandContent }
            </div>
            : null
          }
        </div>
      </div>
    ) : null
  }
}

export default Preview



// WEBPACK FOOTER //
// ./src/components/Preview/index.js